module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/~/core-js/modules/_html.js
// module id = ../../../../core-js/modules/_html.js
// module chunks = 3